<template>
  <div class="login">
    <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 mx-auto">
      <b-card :title="$t('reg')" class="text-center">
        <form v-on:change="validate()" v-on:submit.prevent="register()" novalidate class="is-invalid">
          <div class="form-group field-login-form-last_name">
            <label class="control-label">{{ $t("family") }}</label>
            <input
              v-model="data.body.last_name"
              type="text"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors['last_name'] }"
              required
            />
            <div class="invalid-feedback" v-show="errors['last_name']">{{ errors["last_name"] }}</div>
            <div class="help-block"></div>
          </div>
          <div class="form-group field-login-form-name">
            <label class="control-label">{{ $t("name") }}</label>
            <input
              v-model="data.body.name"
              type="text"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors['name'] }"
              required
            />
            <div class="invalid-feedback" v-show="errors['name']">{{ errors["name"] }}</div>
            <div class="help-block"></div>
          </div>
          <div class="form-group field-login-form-second_name">
            <label class="control-label">Отчество</label>
            <input
              v-model="data.body.second_name"
              type="text"
              class="form-control"
              v-bind:class="{ 'is-invalid': errors['second_name'] }"
              required
            />
            <div class="invalid-feedback" v-show="errors['second_name']">{{ errors["second_name"] }}</div>
            <div class="help-block"></div>
          </div>
          <div class="form-group field-login-form-email">
            <label class="control-label">{{ $t("mail") }}</label>
            <input
              type="text"
              class="form-control"
              v-model="data.body.email"
              required
              v-bind:class="{ 'is-invalid': errors['email'] }"
            />
            <div class="invalid-feedback" v-show="errors['email']">{{ errors["email"] }}</div>
            <div class="help-block"></div>
          </div>

          <b-form-group id="phoneInputGroup" label="Номер телефона:" label-for="phone">
            <vue-tel-input
              id="phone"
              v-model="data.body.phone"
              placeholder="Введите номер телефона"
              :preferredCountries="['ru', 'us', 'gb', 'ua']"
            />
            <div class="text-danger" v-show="errors['phone']">{{ errors["phone"] }}</div>
          </b-form-group>

          <b-button v-if="logging" disabled class="btn btn-primary btn-block">Идёт создание пользователя</b-button>
          <b-button v-else type="submit" class="btn btn-primary btn-block">{{ $t("doreg") }}</b-button>
          <b-progress v-if="logging" :value="logging" variant="success" striped :animated="animate"></b-progress>
        </form>
      </b-card>
    </div>
    <b-modal id="success" ref="success_registration" title="Успешная регистрация">
      <p class="my-4">{{ $t("cre") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary">
          {{ $t("ok") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<i18n>
    {
    "en": {
    "reg": "Create account",
    "login": "Login",
    "mail": "E-mail",
    "pass": "Enter password",
    "passaga": "Confirm the password",
    "family": "Last name",
    "name": "First name",
    "agre": "I agree with the conditions of",
    "agrem": "user agreement",
    "doreg": "Sign up",
    "forg": "Forgot your password?",
    "non": "Did not receive the letter?",
    "alrreg": "Already registered? Log in!",
    "cre": "Account has been successfully created!",
    "ok": "Ok"

    },
    "ru": {
    "reg": "Создание аккаунта",
    "login": "Имя пользователя",
    "mail": "Адрес электронной почты (e-mail)",
    "pass": "Введите пароль",
    "passaga": "Подтвердите пароль",
    "family": "Фамилия",
    "name": "Имя",
    "agre": "Я согласен с условиями",
    "agrem": "пользовательского соглашения",
    "doreg": "Создать",
    "forg": "Забыли пароль?",
    "non": "Не пришло письмо?",
    "alrreg": "Уже зарегистрированы? Войдите!",
    "cre": "Аккаунт успешно создан!",
    "ok": "Ok"

    }
    }
</i18n>

<script>
import VueTelInput from "vue-tel-input";
export default {
  components: {
    VueTelInput,
  },
  data() {
    return {
      agreemnt: true,
      context: "register context",
      errors: [],
      timer: null,
      logging: false,
      key_sent: false,
      data: {
        body: {
          username: "",
          email: "",
          phone: "",
          last_name: "",
          name: "",
        },
        autoLogin: false,
        rememberMe: false,
      },
      sended: false,
      error: null,
    };
  },

  methods: {
    validate() {
      if (this.sended === true) {
        this.$http
          .put("mst/register?validate=true", {
            "register-form": this.data.body, // Axios
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            // this.errors = response.data.errors
            if (response.data.errors) {
              this.errors = [];
              for (var prop in response.data.errors) {
                var key = prop.replace("register-form-", "");
                this.errors[key] = response.data.errors[prop][0];
              }
            }
          });
      }
    },
    send_key() {
      this.$http
        .get("user/get-secret", {
          params: {
            phone: this.data.body.phone,
          },
        })
        .then((response) => {
          alert(response.data);
          this.key_sent = true;
        });
    },
    register() {
      if (this.data.body.password !== this.data.body.password2) {
        alert("Введенные вами пароли не совпадают");
        return false;
      }
      this.logging = 0;
      this.timer = setInterval(() => {
        if (this.logging < 100) {
          this.logging += 10;
        }
      }, 10);
      this.$http
        .post("mst/register", {
          "register-form": this.data.body,
        })
        .then(() => {
          clearInterval(this.timer);
          this.logging = false;
          this.$refs.success_registration.show();
          return false;
        })
        .catch((e) => {
          clearInterval(this.timer);
          this.logging = false;
          if (e.response.data.errors) {
            this.sended = true;
            this.errors = [];
            for (var prop in e.response.data.errors) {
              var key = prop.replace("register-form-", "");
              this.errors[key] = e.response.data.errors[prop][0];
            }
          }
        });
    },
  },
};
</script>
